// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Modal_contentWrapper__EpYLU","actionWrapper":"Modal_actionWrapper__Ceew+","headerWrapper":"Modal_headerWrapper__6zZJd"};